var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{attrs:{"id":"label-404"}},[_vm._v("La page que vous demandez est introuvable.")])
}
var staticRenderFns = []

export { render, staticRenderFns }